import { ReactElement, ReactNode, useState } from 'react';
import AccordionIcon from '../SessionConfigs/AccordionIcon';

interface OptionSectionProps {
  title: ReactNode;
  /** 'top' renders the outer Options header (h3); 'nested' renders a sub-section header (h4). */
  variant?: 'top' | 'nested';
  /** Optional right-aligned content in the header row (e.g. current value or live status). */
  status?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

export default function OptionSection({
  title,
  variant = 'nested',
  status,
  defaultOpen = false,
  children,
}: OptionSectionProps): ReactElement {
  const [open, setOpen] = useState(defaultOpen);
  const isTop = variant === 'top';

  return (
    <div className={isTop ? 'cr-mb-4 cr-mt-8' : 'cr-mt-6'}>
      <div
        className={
          'cr-justify-left cr-flex cr-cursor-pointer cr-items-center cr-gap-2'
          + (isTop ? ' cr-transition-colors cr-duration-200 hover:cr-text-blue-500' : '')
        }
        onClick={() => setOpen(!open)}
      >
        <AccordionIcon show={open} />
        {isTop ? (
          <h3 className="cr-text-lg cr-font-semibold">{title}</h3>
        ) : (
          <h4 className="cr-text-md cr-font-medium cr-text-blue-900">{title}</h4>
        )}
        {status != null && <div className="cr-ml-auto cr-flex cr-items-center">{status}</div>}
      </div>
      {open && <div className="cr-pt-4">{children}</div>}
    </div>
  );
}
